<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      userInput: "",
      codes: [
        "TO THE MOON",
        "TOTHEMOON",
        "to the moon",
        "tothemoon",
        "To the moon",
        "Tothemoon",
      ],
      show: true,
    };
  },
  mounted() {},
  methods: {
    submit() {
      if (this.codes.indexOf(this.userInput)>=0) {
        this.show = false;
      } else {
        alert("Wrong code");
      }
    },
  },
  computed: {},
};
</script>

<template>
  <div class="popup-ctn" v-if="show">
    <div class="popup">
      <div class="head">
        <div class="title">
          Please enter the <br class="lg:hidden block" />
          SECRET <br class="hidden lg:block" />
          CODE to <br class="lg:hidden block" />
          MINT your PUNK <br class="lg:hidden block" />
          ANGELS NFT <br class="lg:hidden block" />
        </div>
        <input type="text" v-model="userInput" placeholder="Enter CODE" />
      </div>

      <button class="foot" @click="submit">GET ACCESS</button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.popup-ctn {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  background: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
}
.popup {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);  
  width: 336px;
  height: 510px;
  background: #2d1630;
  border: 3px solid #e91ea4;
  box-sizing: border-box;
  box-shadow: 0px 0px 30px 9px rgba(233, 30, 164, 0.54);
  border-radius: 27px;
  @media (min-width: 1024px) {
    margin-left: auto;
    margin-right: auto;
    width: 600px;
    height: 520px;
  }
  .head {
    position: relative;
    width: 293px;
    height: 305px;
    font-family: "Saira condensed";
    color: white;
    font-style: normal;
    font-weight: 700;
    font-size: 30px;
    line-height: 39px;
    text-align: center;
    margin-top: 32px;
    margin-right: 24px;
    margin-left: 19px;
    @media (min-width: 1024px) {
      width: 498px;
      height: 305px;
      margin-top: 52px;
      margin-right: 53px;
      margin-left: 52px;
      font-weight: 700;
      font-size: 40px;
      line-height: 46px;
    }

    input {
      position: absolute;
      top: 231px;
      left: 25px;
      width: 248px;
      height: 74px;
      background: rgba(255, 254, 255, 0.2);
      border-radius: 20px;
      text-align: center;
      outline: none;
      padding: 0px 10px;

      &::placeholder {
        color: white;
      }

      @media (min-width: 1024px) {
        position: absolute;
        width: 319px;
        height: 74px;
        top: 206px;
        left: 90px;
      }
    }
  }

  button.foot {
    width: 294px;
    height: 67px;
    position: absolute;
    top: 400px;
    right : 21px;
    bottom : 32px;
    left : 21px;
    background: #2d1630;
    border: 2px solid #e91ea4;
    box-sizing: border-box;
    box-shadow: 0px 0px 15px 7px rgba(233, 30, 164, 0.54);
    border-radius: 110px;
    font-family: "Saira Condensed";
    font-style: normal;
    font-weight: 500;
    font-size: 35px;
    line-height: 55px;
    color: #ffffff;

    @media (min-width: 1024px) {
      position: absolute;
      top: 400px;
      right : 155px;
      bottom : 51px;
      left : 155px;
    }
  }
}
</style>
